import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ObjectAttributeFieldsDataGrid } from "src/components/views/erp/objectAttributes/management/ObjectAttributeFieldsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/common/objectAttributeFields")({
	staticData: { title: i18n.t("attribute_fields"), legacyViewKey: "objectAttributeFieldsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ObjectAttributeFieldsDataGrid />;
}
